import { DataTypeType, GenericDataType } from 'modules/domains';
import { BaseOption } from 'ui/selects';
import { useTranslation } from '../../../../hooks/useTranslation';
import { allEvents, eventLabels } from '../../../../constants';

const isCustomEvent = (event: DataTypeType) => event === GenericDataType.CustomEvent;

export const useEventOptions = (): BaseOption<string>[] => {
  const events = [...allEvents];
  const { t, ready } = useTranslation();
  return ready
    ? events.map((event) => {
        const suffixTranslation = isCustomEvent(event) ? 'eventType.custom' : 'eventType.system';
        const Suffix = t(suffixTranslation);
        return {
          id: event,
          value: event,
          label: eventLabels[event],
          Suffix,
        };
      })
    : [];
};
